module.exports = __webpack_public_path__ + "static/media/vithas@2x.85cc9a9b.jpg";